const translations = {
    applicationDetails: 'Application Details',
    notes: 'Notes',
    productDetails: 'Product Details',
    title: 'Product Usage Report'
};

export default translations;
